import ModalHeader from '@modules/common/components/Modal/ModalHeader';
import { OracleQuantifyStepDefinition } from '@modules/oracle/components/OracleQuantifyStepDefinition';
import { WisdomSearchResponseStepDetailsDialogBanner } from '@modules/oracle/components/OracleSearchResponseStepDetailsDialog/WisdomSearchResponseStepDetailsDialogBanner';
import { useGetQuantifyChartEQLProps } from '@modules/quantify/hooks';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
} from '@mui/material';
import { AssistantResponseEqlToken } from 'generated/graphql';
import { useGetEQLExpression } from 'v2/core/repository/edge-server/eql/useGetEQLExpression';
import { useGetUser } from 'v2/core/services/user';
import { OracleResponseStepSubmitButton } from './OracleResponseStepSubmitButton';

interface OracleQuantifyResponseStepDetailsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  isReadOnly?: boolean;
  promptID: string;
  stepID: string;
  assistantResponseEqlToken: AssistantResponseEqlToken;
  stepTitle: string;
}

export function OracleQuantifyResponseStepDetailsDialog({
  onClose,
  isOpen,
  isReadOnly,
  promptID,
  stepID,
  assistantResponseEqlToken,
  stepTitle,
}: OracleQuantifyResponseStepDetailsDialogProps) {
  const {
    tenant: { id: tenantID },
  } = useGetUser();
  const eqlProps = useGetQuantifyChartEQLProps();
  const { eql } = useGetEQLExpression({
    tenantID,
    eqlProps,
  });

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      PaperProps={{ elevation: 0 }}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer,
        '& .MuiDialogContent-root': {
          padding: (theme) => theme.spacing(2),
        },
        '& .MuiDialogActions-root': {
          padding: (theme) => theme.spacing(1),
        },
      }}
    >
      <ModalHeader
        title={`${isReadOnly ? 'Inspect' : 'Edit'} Query`}
        onClose={onClose}
      />
      <Divider
        sx={{
          opacity: 0.12,
        }}
      />
      <WisdomSearchResponseStepDetailsDialogBanner stepTitle={stepTitle} />
      <DialogContent dividers>
        <OracleQuantifyStepDefinition
          isReadOnly={isReadOnly}
          eqlQuery={assistantResponseEqlToken.eql}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        {isReadOnly ? null : (
          <OracleResponseStepSubmitButton
            promptID={promptID}
            stepID={stepID}
            eql={eql}
          />
        )}
      </DialogActions>
    </Dialog>
  );
}
